module.exports = __webpack_public_path__ + "public/SiteIcons/defaultIcon.png?71959402";